import React from 'react';
import {Route} from "react-router-dom";
import {compose} from "redux";
import {connect} from 'react-redux';
import {PathBreadcrumbItem, withBreadcrumbCurried} from "../../Boilerplate/BreadcrumbContext";
import ListEdit from "./ListEdit";
import ListDetail from "./ListDetail";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {getContactList} from "../../../actions/contactlists";

const ContactList = () => <div>
  <Route exact path="/settings/contact-lists/:listId" component={ListDetail}/>
  <Route path="/settings/contact-lists/:listId/new" component={ListDetail}/>
  <Route path="/settings/contact-lists/:listId/edit" component={ListEdit}/>
</div>;

const ContactListBreadcrumb = props => PathBreadcrumbItem({ path: '/settings/contact-lists/', resource: props.list });

export default compose(
  connect(
    (state, props) => {
      const list = state.view.data[props.match.params.listId];
      const viewPath = state.view.path.slice(-1)[0];
      const urlPath = props.match.params.listId;
      if (viewPath !== urlPath) return { loading: true };
      if (!list) return { loading: true };
      return { list };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getContactList({ id: props.match.params.listId }))
    }),
  ),
  withLoading,
  withBreadcrumbCurried(ContactListBreadcrumb)
)(ContactList);




// WEBPACK FOOTER //
// ./src/components/Settings/ContactLists/ContactList.js